import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from "../layout";
import ScrollToTop from "./ScrollToTop";
import Aboutus from "../components/AboutUs/Aboutus";
import Home from "../components/Home/Home";
import Contactus from "../components/Contactus/ContactUs";
import Webinar from "../components/Webinar/Webinar";
import NewPage from "../components/NewPage/NewPage";
// import LandingPage from "../components/LandingPage/LandingPage";
import CoursePage from "../components/CoursePage/CoursePage";
import FullStack from "../components/CoursePage/FullStack";
import CyberSecurity from "../components/CoursePage/CyberSecurity";
import DataAnalytics from "../components/CoursePage/DataAnalytics";
import DataScience from "../components/CoursePage/DataScience";
import PopUpScreen from '../components/PopUp/PopUpScreen';
import Enquiry from '../components/Enquiry/Enquiry';
import Terms from '../components/Terms&Conditions/Terms';

export default function ApplicationRoutes() {
  const [isModalOpen, setIsModalOpen] = useState(true);

  return (
    <>
      <ScrollToTop /> 
      {isModalOpen && <PopUpScreen onClose={() => setIsModalOpen(false)} />}     
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/course" element={<CoursePage />} />
          <Route path="/about" element={<Aboutus />} />
          <Route path="/contact" element={<Contactus />} />
          <Route path="/webinar" element={<Webinar />} />
          <Route path="/programs/fullstack" element={<FullStack />} />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/programs/cybersecurity" element={<CyberSecurity />} />
          <Route path="/programs/data-science" element={<DataScience />} />
          <Route path="/programs/data-analytics" element={<DataAnalytics />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/new" element={<NewPage />} />

        </Routes>
      </Layout>
    </>
  );
}
